import { render } from "./NoAlerts.vue?vue&type=template&id=084bee89"
import script from "./NoAlerts.vue?vue&type=script&lang=js"
export * from "./NoAlerts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__